import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useControlNext from '@gef-ui/form-core/hooks/state/useControlNext';
import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { replaceData } from '@gef-ui/form-core/stream/transfer/control';

import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import producedProduction from 'features/views/production/common';
import newProducedProduction from 'features/views/productionNew';
import { PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME } from 'features/views/productionNew/form';

import ActionButtons from './components/ActionButtons';
import Client from './components/Client';
import Document from './components/Document';
import Header from './components/Header';

const { productionStatuses } = producedProduction.constants;

export const ProducedProductionNewModalBody = ({ document, mainFilterFormData }) => {
	const dispatch = useDispatch();
	const next = useControlNext(PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME);
	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	const isEditMode = useSelector(newProducedProduction.selectors.getIsEditMode);

	useEffect(() => {
		const data = document || {};

		if (formIsInitiated) {
			const finalData = {
				...data,
				personIn: data?.businessIn || data?.personIn,
				sellerIn: data?.sellerIn,
				policyNo: data?.policyNo,
				policyNumber: String(data?.policyNo || ''),
				firstName: data?.firstname || '',
				scannedDocument: data?.scanned,
				documentType: data?.documentTypeId,
			};

			next(replaceData({ data: finalData }));
		}
	}, [dispatch, document, isEditMode, formIsInitiated, next]);

	useEffect(
		() => () => {
			dispatch(newProducedProduction.actions.reset());
		},
		[dispatch],
	);

	const data = document || {};
	const status = data.productionDocStatus || data.productionStatus;
	const isClosed = productionStatuses[status] === productionStatuses.CLOSED;
	const { reportedDate } = data;

	return (
		<Stack spacing={3}>
			<SubmitFormDialog pageName={PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME} />
			<Header
				editMode={isEditMode}
				isClosed={isClosed}
				reportedDate={reportedDate}
				organisationStructure={data?.organisationStructure}
				mainFilterFormData={mainFilterFormData}
			/>
			<Client isClosed={isClosed} />
			<Document isClosed={isClosed} />
			<ActionButtons isClosed={isClosed} />
		</Stack>
	);
};

ProducedProductionNewModalBody.propTypes = {
	document: PropTypes.object,
	mainFilterFormData: PropTypes.object,
};

export default ProducedProductionNewModalBody;
